import React from 'react';
import { Heart, Award, Users, Leaf } from 'lucide-react';
import { mockData } from '../mock';
import SEO from '../components/SEO';

const About = () => {
  const { about, doula } = mockData;

  return (
    <div className="about-page">
      <SEO 
        title="About 12 Tribes Doula Services | Culturally-Centered Birth Support in Central Georgia"
        description="Meet your Central Georgia doula. Over 8 years supporting Black mothers through holistic pregnancy, birth, and postpartum care rooted in ancestral wisdom and natural healing."
        keywords="Black doula Central Georgia, culturally centered birth support, holistic doula Macon GA, experienced birth doula Georgia, natural birth support"
        url="https://georgia-birth-coach.preview.emergentagent.com/about"
      />
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="heading-hero">About {doula.name}</h1>
          <p className="body-large" style={{maxWidth: '700px', margin: '0 auto'}}>Dedicated to serving Black mothers with holistic care, ancestral wisdom, and unwavering support</p>
        </div>
      </section>

      {/* Bio Section */}
      <section className="bio-section">
        <div className="container">
          <div className="bio-content">
            <div className="bio-image-container centered">
              <img 
                src="https://images.pexels.com/photos/6393375/pexels-photo-6393375.jpeg?auto=compress&cs=tinysrgb&w=800" 
                alt="Black mother with baby showing care and connection" 
                className="bio-image"
              />
            </div>
            <div className="bio-text">
              <h2 className="heading-2">My Journey as a Doula</h2>
              <p className="body-medium">{about.bio}</p>
              <p className="body-medium" style={{marginTop: '1.5rem'}}>{about.mission}</p>
              <div className="experience-badge">
                <Award size={24} />
                <span className="body-small">{about.experience}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Approach Section */}
      <section className="approach-section">
        <div className="container">
          <h2 className="heading-1">My Approach</h2>
          <div className="approach-grid">
            <div className="approach-card">
              <Heart size={28} className="approach-icon" />
              <h3 className="heading-3">Centering Black Women</h3>
              <p className="body-small">Creating a safe space where Black mothers are seen, heard, and celebrated. Your experiences, concerns, and cultural needs are at the center of all care.</p>
            </div>
            <div className="approach-card">
              <Leaf size={28} className="approach-icon" />
              <h3 className="heading-3">Natural & Holistic</h3>
              <p className="body-small">Using herbs, teas, and natural remedies alongside evidence-based practices to support your body's innate wisdom and healing capacity.</p>
            </div>
            <div className="approach-card">
              <Users size={28} className="approach-icon" />
              <h3 className="heading-3">Community Centered</h3>
              <p className="body-small">Building connections and support networks that extend beyond birth, creating a village of care for you and your family.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="philosophy-section">
        <div className="container">
          <div className="philosophy-content">
            <h2 className="heading-2">Birth Philosophy</h2>
            <div className="philosophy-text">
              <p className="body-medium">I believe that birth is a sacred, powerful experience that belongs to you. My role is to walk beside you, offering knowledge, comfort, and unwavering support while honoring your autonomy and choices.</p>
              <p className="body-medium">Drawing from the strength of our ancestors and the healing power of nature, I help create birth experiences that are empowering, safe, and deeply connected to our cultural heritage.</p>
              <p className="body-medium">Every mother deserves to feel confident, informed, and supported. Every baby deserves to enter the world surrounded by love and reverence. This is the foundation of my practice.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
